import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import Header from "templates/default/components/Header/Header.jsx";
import Footer from "templates/default/components/Footer/Footer.jsx";
import { postRecord } from "services/services";
import { AuthContext } from "context/Authentication";

const API_GetAllPolicyDocuments = "policy_documents/getall";

export default function Policy() {
  const { title } = useParams();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const context = useContext(AuthContext);

  useEffect(() => {
    const fetchPolicies = async () => {
      const response = await postRecord(API_GetAllPolicyDocuments, {});
      if (response.status === 200 && response.data) {
        const matchedPolicy = response.data.find(
          (policy) => policy.Title.toLowerCase().replace(/ /g, "-") === title
        );
        try {
          const urlpath = process.env.BASEURL + matchedPolicy.File_Path;
          const resp = await fetch(urlpath); // Replace with your file URL
          if (!resp.ok) throw new Error("Failed to fetch file");
          const data = await resp.text();
          matchedPolicy.Content = data;
          // setThisPolicyDocument({ ...thisPolicyDocument, Content: data });
        } catch (error) {
          console.error("Error fetching the file:", error);
        }
        setPolicy(matchedPolicy);
      }
      setLoading(false);
    };

    fetchPolicies();
  }, [title]);

  return (
    <React.Fragment>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
      >
        <Header />
        <Container maxWidth="xl">
          <Box sx={{ position: "relative", py: 20, textAlign: "left" }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
                <CircularProgress />
              </Box>
            ) : policy ? (
              <React.Fragment>
                <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
                  {policy.Title}
                </Typography>
                <Box
                  sx={{
                    width: "80px",
                    height: "2px",
                    backgroundColor: "primary.main",
                    mb: 4,
                  }}
                />
                <Card>
                  <CardContent>
                    <div dangerouslySetInnerHTML={{ __html: policy.Content }} />
                  </CardContent>
                </Card>
              </React.Fragment>
            ) : (
              <Typography variant="h6" color="error">
                Policy not found.
              </Typography>
            )}
          </Box>
        </Container>
      </Box>
      <Footer />
    </React.Fragment>
  );
}
